"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const createConsoleArgs_1 = __importDefault(require("./createConsoleArgs"));
const createLogject_1 = __importDefault(require("./createLogject"));
const levels_1 = require("./levels");
const levelLog = (config) => {
    const { level, logToConsole, scribe, targetLevel, scribeTargetLevel } = config;
    if (!(0, levels_1.isLevelActive)(level.name, targetLevel)) {
        return;
    }
    const method = level.consoleMethod;
    const logJect = (0, createLogject_1.default)(config, config.args);
    if (logToConsole) {
        console[method](...(0, createConsoleArgs_1.default)(logJect));
    }
    if (scribe && (0, levels_1.isLevelActive)(level.name, scribeTargetLevel)) {
        scribe.log(logJect);
    }
};
exports.default = levelLog;
//# sourceMappingURL=levelLog.js.map